interface Props {
  title: string;
}

export const StoryboardFallback = ({ title }: Props) => (
  <div className="border border-warning-border bg-warning-light p-4 rounded-md">
    <h3 className="font-semibold text-warning-foreground">{title}</h3>
    <p className="mt-2 text-sm text-warning-foreground">
      Rendering for this content element is not yet implemented.
    </p>
  </div>
);
